"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatDate = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
let ChatDate = class ChatDate extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.label = '';
    }
    render() {
        return (0, lit_1.html) `
      <mm-tag>
        ${this.label}
        <slot></slot>
      </mm-tag>
    `;
    }
};
ChatDate.styles = (0, lit_1.css) `
    :host {
      display: flex;
      justify-content: center;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChatDate.prototype, "label", void 0);
ChatDate = __decorate([
    (0, decorators_js_1.customElement)('mm-chat-date')
], ChatDate);
exports.ChatDate = ChatDate;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhdC1kYXRlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY2hhdC1kYXRlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFFM0QsK0JBQTRCO0FBR3JCLElBQU0sUUFBUSxHQUFkLE1BQU0sUUFBUyxTQUFRLGdCQUFVO0lBQWpDOztRQU91QixVQUFLLEdBQUcsRUFBRSxDQUFBO0lBVXhDLENBQUM7SUFSQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7VUFFTCxJQUFJLENBQUMsS0FBSzs7O0tBR2YsQ0FBQTtJQUNILENBQUM7O0FBZk0sZUFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7OztHQUtsQixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzt1Q0FBVztBQVAzQixRQUFRO0lBRHBCLElBQUEsNkJBQWEsRUFBQyxjQUFjLENBQUM7R0FDakIsUUFBUSxDQWlCcEI7QUFqQlksNEJBQVEifQ==